"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryStockTab = void 0;
const router_1 = require("client/components/router");
const store_1 = require("client/modules/inventory/modules/inventory-list/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_inventory_stock_1 = require("../../components/edit-inventory-stock");
let InventoryStockTab = class InventoryStockTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handelCancel = () => {
            router_1.RouteManager.transitionTo("/lots/pharmacies");
        };
        this.handleSave = (site, inventoryMetas) => {
            store_1.inventoryListStore.updateInventorySiteLots(site, inventoryMetas);
        };
    }
    componentWillMount() {
        // inventoryListStore.loadInventory();
        // const options = {
        //   count: 100,
        //   start: 0,
        //   where: this.props.params
        //     ? `inventorysite.siteId = ${this.props.params[0]}`
        //     : ""
        // };
        // inventoryListStore.loadInventory(options);
    }
    render() {
        return (React.createElement("div", { className: "sites__form" },
            React.createElement(edit_inventory_stock_1.EditInventoryStock, { error: store_2.sitesDetailStore.inventorysites.error, loading: store_2.sitesDetailStore.site.loading, status: store_2.sitesDetailStore.site.status, onCancel: this.handelCancel, onSave: this.handleSave, site: store_2.sitesDetailStore.site.value })));
    }
};
InventoryStockTab = __decorate([
    mobx_react_1.observer
], InventoryStockTab);
exports.InventoryStockTab = InventoryStockTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/tabs/inventory-stock/inventory-stock.tsx
// module id = 4117
// module chunks = 0